

export const reasonsData = [
    'Diskret & zuverlässig',
    'Schnell bei Ihnen vor Ort',
    'Transparente Angebote',
    ' Kein Callcenter'
];
